// Mock data for Sun Lumia Overseas website

import jaiminimg from "../assets/jaiminimg.jpeg";

export const companyInfo = {
  name: "Sun Lumia Overseas",
  tagline: "Your Gateway to Global Education",
  email: "sunlumiaoverseas@gmail.com",
  phone: "+91 97234 45102",
  telephone: "+91 79 2322 4104",
  altPhone: "+91 96243 62046",
  address:
    "Q-4, 3rd Floor, Suman Tower, Nr Hotel Haveli, Sector-11, Gandhinagar - 382011, Gujarat, India",
  established: 2010,
  director: "Mr. Jaimin Patel",
  studentsHelped: 1000,
  countriesServed: 8,
  universities: 150,
  successRate: 97,
  whatsapp: "+919723445102",
};

export const heroSlides = [
  {
    id: 1,
    title: "Your Journey to",
    highlight: "Global Education",
    subtitle:
      "Expert visa guidance and counselling for students aspiring to study in top universities worldwide.",
    image:
      "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=1920&q=80",
    cta: "Get Free Counselling",
  },
  {
    id: 2,
    title: "Study Abroad with",
    highlight: "Confidence",
    subtitle:
      "Over 1000+ students successfully placed in UK, USA, Canada, Australia and more.",
    image:
      "https://images.unsplash.com/photo-1544717305-2782549b5136?w=1920&q=80",
    cta: "Explore Countries",
  },
  {
    id: 3,
    title: "Trusted Visa",
    highlight: "Consultancy",
    subtitle:
      "Gujarat's leading education consultancy with 97% visa success rate since 2010.",
    image:
      "https://images.unsplash.com/20/cambridge.JPG?w=1920&q=80",
    cta: "Contact Us Today",
  },
];

export const services = [
  {
    id: 1,
    title: "Student Visa Services",
    description:
      "Complete assistance with student visa applications for all major countries. We handle documentation, interview prep, and follow-ups.",
    icon: "GraduationCap",
    image:
      "https://images.unsplash.com/photo-1581553673739-c4906b5d0de8?w=600&q=80",
  },
  {
    id: 2,
    title: "Free Counselling",
    description:
      "Expert counselling sessions to help you choose the right country, university, and course based on your profile and aspirations.",
    icon: "Users",
    image:
      "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=600&q=80",
  },
  {
    id: 3,
    title: "University Selection",
    description:
      "Access to 150+ partner universities globally. We match your profile with the best institutions for guaranteed admission.",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?w=600&q=80",
  },
  {
    id: 4,
    title: "Business Franchise",
    description:
      "Join our growing network of education consultancy offices. Expand with a proven business model across India.",
    icon: "Briefcase",
    image:
      "https://images.pexels.com/photos/301926/pexels-photo-301926.jpeg?w=600",
  },
];

export const countries = [
  {
    id: 1,
    name: "United States",
    code: "USA",
    slug: "usa",
    flag: "https://flagcdn.com/w320/us.png",
    image:
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600&q=80",
    universities: 35,
    description:
      "Access top Ivy League schools and leading research institutions across America.",
  },
  {
    id: 2,
    name: "Canada",
    code: "CAN",
    slug: "canada",
    flag: "https://flagcdn.com/w320/ca.png",
    image:
      "https://images.unsplash.com/photo-1517935706615-2717063c2225?w=600&q=80",
    universities: 30,
    description:
      "Explore affordable education with excellent post-study work opportunities in Canada.",
  },
  {
    id: 3,
    name: "Australia",
    code: "AUS",
    slug: "australia",
    flag: "https://flagcdn.com/w320/au.png",
    image:
      "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=600&q=80",
    universities: 25,
    description:
      "Experience world-class education in a multicultural environment down under.",
  },
  {
    id: 4,
    name: "Germany",
    code: "DEU",
    slug: "germany",
    flag: "https://flagcdn.com/w320/de.png",
    image:
      "https://images.unsplash.com/photo-1599946347371-68eb71b16afc?w=600&q=80",
    universities: 20,
    description:
      "Tuition-free education at world-renowned universities in the heart of Europe.",
  },
  {
    id: 5,
    name: "Italy",
    code: "ITA",
    slug: "italy",
    flag: "https://flagcdn.com/w320/it.png",
    image:
      "https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=600&q=80",
    universities: 15,
    description:
      "Study in the birthplace of Renaissance — art, culture, and academic excellence.",
  },
  {
    id: 6,
    name: "United Kingdom",
    code: "UK",
    slug: null,
    flag: "https://flagcdn.com/w320/gb.png",
    image:
      "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80",
    universities: 40,
    description:
      "Study at world-renowned universities like Oxford, Cambridge, and Imperial College London.",
  },
];

export const stats = [
  { id: 1, value: 1000, suffix: "+", label: "Students Placed" },
  { id: 2, value: 150, suffix: "+", label: "Partner Universities" },
  { id: 3, value: 97, suffix: "%", label: "Visa Success Rate" },
  { id: 4, value: 15, suffix: "+", label: "Years Experience" },
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    course: "MSc Computer Science, University of Manchester",
    country: "UK",
    text:
      "Sun Lumia Overseas made my dream of studying in the UK a reality. Their guidance throughout the visa process was exceptional. Highly recommended!",
    rating: 5,
  },
  {
    id: 2,
    name: "Rahul Patel",
    course: "MBA, University of Toronto",
    country: "Canada",
    text:
      "From university selection to visa approval, the team at Sun Lumia handled everything professionally. I got my Canada student visa in just 3 weeks!",
    rating: 5,
  },
  {
    id: 3,
    name: "Anita Desai",
    course: "Bachelor of Engineering, University of Melbourne",
    country: "Australia",
    text:
      "The counsellors at Sun Lumia are very knowledgeable and supportive. They helped me get a scholarship at my dream university in Australia.",
    rating: 5,
  },
];

export const faqs = [
  {
    id: 1,
    question: "What services does Sun Lumia Overseas provide?",
    answer:
      "We provide comprehensive services including student visa assistance, university selection, documentation support, interview preparation, IELTS/TOEFL coaching guidance, and post-visa support for countries like UK, USA, Canada, Australia, New Zealand, Ireland, Germany, and France.",
  },
  {
    id: 2,
    question: "Is the counselling session free?",
    answer:
      "Yes, we offer free counselling sessions to all students. Our expert counsellors will assess your profile and guide you on the best country and university options.",
  },
  {
    id: 3,
    question: "Can I study abroad without IELTS?",
    answer:
      "Yes! Some countries and universities accept students without IELTS. For example, many Irish universities offer admission without IELTS. Contact us to learn about all your options.",
  },
  {
    id: 4,
    question: "What is the visa success rate?",
    answer:
      "We maintain a 97% visa success rate. Our experienced team ensures thorough documentation and proper guidance for a smooth visa process.",
  },
  {
    id: 5,
    question: "How long does the visa process take?",
    answer:
      "The visa processing time varies by country — typically 2-8 weeks. We start the process well in advance to ensure timely visa approval before your course starts.",
  },
];

export const aboutContent = {
  intro:
    "Sun Lumia Overseas, one of the largest education consultancies in India, represents over 150 education institutions globally. Our network of offices is manned with experienced personnel dedicated to making your study abroad dream a reality.",

  story:
    "The company, Sun Lumia Overseas, was established in the year 2010. The director Mr. Jaimin Patel started with the objective to provide real and genuine guidance to foreign aspirants and career-oriented students. In this short span of time, the company has achieved milestones in the field of visa and guidance services. So far we have done thousands of visas for different countries and made the clients delighted.",

  achievement:
    "We have sent over 1000 students to UK, USA, Canada, Australia, New Zealand & other countries successfully, from across India since our inception. According to a survey, we alone command 40% of the foreign education sector in Gujarat.",

  mission:
    "To provide genuine, transparent, and comprehensive guidance to students aspiring to pursue their education abroad, ensuring they make informed decisions about their future.",

  vision:
    "To be the most trusted and preferred overseas education consultancy in India, helping thousands of students achieve their global education dreams.",

  founderName: "Mr. Jaimin Patel",

  founderDesignation: "Founder & Director",

  founderBio:
    "With over 15 years of experience in the overseas education industry, Mr. Jaimin Patel founded Sun Lumia Overseas in 2010 with a vision to provide authentic and reliable guidance to students. Under his leadership, the company has grown to become one of Gujarat's leading education consultancies, successfully placing over 1000 students in top universities worldwide.",

  founderImage: jaiminimg,
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Contact", path: "/contact" },
];